import React, { forwardRef } from 'react';

import { Typography } from '@mui/material';
import { useIntercom } from 'react-use-intercom';
import { BaseSnackbar } from 'src/components';
import { alineLinkStyles } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  link: {
    ...alineLinkStyles,
    cursor: 'pointer',
    marginLeft: theme.spacing(1),
    whiteSpace: 'nowrap',
  },
}));

interface ErrorSnackProps {
  id: string;
  message?: string;
}

export const ErrorSnackbar = forwardRef<HTMLDivElement, ErrorSnackProps>(function ErrorSnackbar(
  { id, message = 'An error has occurred.' }: ErrorSnackProps,
  ref
): JSX.Element {
  const { classes } = useStyles();
  const { show } = useIntercom();

  return (
    <BaseSnackbar ref={ref} id={id} variant="error">
      <Typography variant="caption">{message}</Typography>
      <Typography className={classes.link} variant="caption" onClick={() => show()}>
        Contact support
      </Typography>
    </BaseSnackbar>
  );
});
